import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { ConvertToFloat, isValidArray } from "../../Layout/Common/common";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { QuantityStripper } from "../../Layout/Common/quantityStripper";
import { axiosInstance } from "../../axios/axiosInstance";
import { GlobalContext } from "../../Context/GlobalContext";
import { TransitionGroup, CSSTransition } from "react-transition-group";
// import "../../assets/css/cartList.css";
import { WishlistItem } from "../../Layout/Common/addWhistList";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { ISPICKUPONLY_MESSAGE } from "../../constants";
import { useAuth } from "../../Context/AuthContext";
import { LoadMoreCartItem } from "../../Layout/Common/cartItemDynamicLoad";
import { ProductLink } from "../../Layout/Common/productLink";
import { ItemReferenceInput } from "../../Layout/Common/itemReferenceInput";

export const OrderDetailItemBody = ({ cartItemList, totalItem }) => {
  const [cartItem, setCartItem] = useState(null);
  const [totalCartItem, setCartItemTotal] = useState(null);
  const globalcontext = useContext(GlobalContext);

  useEffect(() => {
    setCartItem(cartItemList);
    setCartItemTotal(totalItem);
  }, [cartItemList, totalItem]);

  const handleDeleteItem = ({ prod_id }) => {
    setCartItem((prevItems) => prevItems.filter((item) => item.prod_id != prod_id));
  };

  return (
    <Fragment>
      {isValidArray(cartItem) && (
        <div className="row">
          <div className="col-lg-12">
            <TransitionGroup>
              {cartItem.map((item, index) => (
                <CSSTransition key={item.prod_id} timeout={300} classNames="card">
                  <CartBodyItem item={item} index={index} handleRemove={handleDeleteItem} />
                </CSSTransition>
              ))}
            </TransitionGroup>
            <LoadMoreCartItem
              orderId={globalcontext.OrderId}
              cartItem={cartItem}
              totalItem={totalCartItem}
              onItemsLoaded={(newItems) => setCartItem((prev) => [...prev, ...newItems])}
            />
          </div>
        </div>
      )}
    </Fragment>
  );
};

const CartBodyItem = ({ item, index, handleRemove }) => {
  const globalcontext = useContext(GlobalContext);
  const { handleDeleteCartItem, deletingProdIds } = useGlobalFunction();
  const isDeleting = deletingProdIds?.has(item.prod_id) ?? false;

  const removeCard = async (item) => {
    const result = await handleDeleteCartItem(item.prod_id, item.order_item_id);
  };

  return (
    <div
      className="cart-added-products flex-column"
      key={index}
      data-id={item.prod_id}
      style={{
        opacity: isDeleting ? 0.5 : 1,
      }}
    >
      <div className="d-flex align-items-start gap-3 w-100">
        <div className="added-cartPro-img">
          <ImageWithDefault src={item.image_th} alt="Product-image" />
        </div>
        <div className="added-cartPro-content">
          <div className="added-cartPro-info">
            <div className="added-cartPro-item">
              <h6>
                <ProductLink to={item.product_url}>{item.description}</ProductLink>
              </h6>
              {isValidArray(globalcontext.pickupOnlyProduct) &&
                globalcontext.pickupOnlyProduct.includes(String(item.prod_id)) && (
                  <div className="text-danger form-validation-message">{ISPICKUPONLY_MESSAGE}</div>
                )}
              <p className="mb-0">
                <span>Code: {item.prod_code}</span>
              </p>
            </div>
            <div className="cart-remove-wishlist">
              <button
                type="submit"
                className="cc-cart-delete"
                disabled={isDeleting}
                onClick={() => {
                  removeCard(item);
                }}
              >
                <i className="fa-regular fa-trash-can" />
              </button>
              <WishlistItem productId={item.prod_id} />
            </div>
          </div>
          <div className="added-cartPro-price align-items-center">
            <div>
              {/* <p className="fw-medium">${ConvertToFloat(item.price_ext_applied)} each</p>
              <p>${ConvertToFloat(item.total_ext)}</p> */}

              <p className="fw-medium mb-0">
                <span>Price Ex.GST: ${ConvertToFloat(item.price_ext_applied)} each</span>
              </p>
              <p className="mb-1">
                <span style={{ fontWeight: 600, color: "#000000ad" }}>
                  Extension Ex.GST: ${ConvertToFloat(item.total_ext)}
                </span>
              </p>
            </div>
            {item.isErrorItem ? (
              <div className="qty-container orderErrorItem">{item.error_message}</div>
            ) : (
              <QuantityStripper
                inline={false}
                prd={item}
                params={{
                  code: item.prod_code,
                  desc: item.description,
                  img: item.image_th,
                }}
              />
            )}
          </div>
          <ItemReferenceInput item={item} />
        </div>
      </div>
    </div>
  );
};
